<template>

  <div class="page-header">
    <h2>My Orders</h2>
  </div>
    <template v-if="userOrders.orders != undefined">
        <template v-for="order in userOrders.orders" v-bind:key="order">
            <div class="w3-card-4 w3-center w3-round-xlarge part" v-bind:style="[order.curr_status.status_id!=-2 ? {'box-shadow': '4px 4px 8px 0 rgba(0,0,0,0.2)', 'background-color' : 'white'} : {'box-shadow': '4px 4px 8px 0 rgba(0,0,0,0.2)', 'background-color' : 'rgb(211, 211, 211) !important'}]">
                <div class="w3-container w3-round collapsible" @click="uncollapse($event, order.id)" v-bind:style="[order.curr_status.status_id!=-2 ? {'background-color' : 'white'} : {'background-color' : 'rgb(211, 211, 211) !important'}]">
                    <table style="width: 100%; table-layout: fixed;">
                        <tr style="font-weight: normal;">
                            <th style="text-align: left; padding-right: 0px">ORDER PLACED</th>
                            <th style="text-align: center">TOTAL</th>
                            <th style="text-align: center; width: 15%">CURRENT STATUS</th>
                            <th style="text-align: center">
                                <template v-if="order.shipment.Address != undefined">
                                    SEND TO
                                </template>
                                <template v-else>
                                  NO <br>
                                   SHIPMENT
                                </template>
                            </th>
                            <th style="text-align: right; ">ORDER N° {{order.id}} <span v-if="order.curr_status==-2"  style="color:red;font-weight:bold;">CANCELLED</span></th>
                            <!-- <th style="text-align: right; width: 15%">NEXT STATUS</th> -->
                        </tr>                
                        <tr style="font-weight: normal;">
                            <th style="text-align: left; with: 15%">{{order.order_date.split('.')[0]}}</th>
                            <th style="text-align: center">{{calculateOrderTotal(order)}} CHF</th>
                            <th style="text-align: center; width: 15%">    
                                <span :title="order.curr_status.description">{{order.curr_status.name}} </span>  
                            </th>
                            <th style="text-align: center">{{order.shipment.Address}}</th>
                            <th style="text-align: right"><a :href=" '/distribution/myorders/'+ order.id"><button >View order</button></a> 
                              {{  }}
                            <!-- <th style="text-align: right; width: 15%">{{order.next_status.name}}</th> -->
                              <button @click="cancelOrder($event, order.id)" :disabled="order.curr_status.status_id!=-1" title="An order can only be cancelled on the 'Wait for Acknowledgement' status.">Cancel order</button>
                            </th>
                        </tr>
                    </table>
                </div>
                <div :id=" 'content_' + order.id " class="w3-container w3-cell-row w3-round" style="display: none;">
                    <div class="w3-cell" style="width:75%">
                        <!-- <br> -->
                        <h6 class="w3-left">ORDER SUMMARY</h6>
                        <br>
                        <ul class="w3-ul">
                            <li></li>
                            <li v-for="part in order.parts" v-bind:key="part">
                                <div class="w3-cell-row">
                                    <div class="w3-cell" style="text-align: left;">
                                        <b>{{part.part_name}}</b>
                                    </div>
                                    <div class="w3-cell" style="text-align: right;">
                                        {{part.ori_quantity}} pieces
                                        <br>
                                        {{calculatePartPrice(part)}} CHF
                                    </div>
                                </div>
                                <ul style="text-align:left;">
                                    <li v-for="(value, input) in part.userinputs" v-bind:key="(value, input)" style="border-bottom:none!important">
                                        <b> {{input}}: </b> {{value}}
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div class="w3-cell" style="text-align: center;">
                        <br>
                        <h6>MORE DETAILS</h6>
                    </div>
                </div>
            </div>
            <br>
        </template>
    </template>
    <template v-else>
        <template v-if="userOrders.status==-1">
            <h5>{{userOrders.errors}}</h5>
        </template>
        <template v-else-if="userOrders == {} ">
          Recovering data...
        </template>
        <template v-else>    
            No orders for this user. <a href="/distribution/order">Place an order!</a>
        </template>
    </template>
</template>

<style scoped src="@/assets/styles.css">

<style scoped>
    .tooltip {
    position: relative;
    display: inline-block;
    }

    .tooltip .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    top: -50%;
    left: 110%;
    }

    .tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 100%;
    margin-top: 0;
    border-width: 5px;
    border-style: solid;
    border-color: transparent black transparent transparent;
    }
    .tooltip:hover .tooltiptext {
    visibility: visible;
    }
</style>

<script>
// import marked from 'marked';

// marked.setOptions({
//   highlight: function(code, lang, callback) {
//     require('pygmentize-bundled') ({ lang: lang, format: 'html' }, code, function (err, result) {
//       callback(err, result.toString());
//     });
//   }
// });

export default {
    name: 'MyOrders',
    props: {
        file_path : String
    },
    data() {
        return {
            userOrders : {}
        }
    },
    computed: {
        userDetails() {
            return this.$store.getters.getUserDetails;
        },
        // orderTotals() {
        //     var totals = []
        //     var order_index;
        //     var order_id;
        //     for (order_index = 0; order_index < orders.length)
        // }
    },
    created() {
        fetch(process.env.VUE_APP_URL+ "/restapi/myorders", {
            method: "GET", 
            headers: {'Accept': 'application/json'}}).then(
                (res) => {
                    res.json().then(
                        (myorders) => {
                            this.userOrders = myorders                            
                            console.log("MyOrders: ", myorders)
                        }
                    )
                }
            );
    },
    methods: {
        calculateOrderTotal: function(order) {
            var total = 0;
            var part_index;
            for (part_index = 0; part_index < order.parts.length; part_index++) {
                var part = order.parts[part_index]
                var price_index;
                var unit_price = part.part_unit_prices[0].chf;
                if (part.part_unit_prices.length > 1)
                {
                    for (price_index = 0; price_index <= part.part_unit_prices.length-1; price_index++) 
                    {
                    if (part.act_quantity >= part.part_unit_prices[price_index].qty && part.act_quantity < part.part_unit_prices[price_index+1].qty )
                        unit_price = part.part_unit_prices[price_index].chf;
                    else if( part.ori_quantity >= part.part_unit_prices[price_index+1].qty)
                        unit_price = part.part_unit_prices[price_index+1].chf;
                    }
                }
                total += unit_price * part.act_quantity;
            }
            return total;
        },
        calculatePartPrice: function(part) {
          var price_index;
          var unit_price = part.part_unit_prices[0].chf;
          if (part.part_unit_prices.length > 1)
          {
            for (price_index = 0; price_index <= part.part_unit_prices.length-1; price_index++) 
            {
              if (part.act_quantity >= part.part_unit_prices[price_index].qty && part.act_quantity < part.part_unit_prices[price_index+1].qty )
                  unit_price = part.part_unit_prices[price_index].chf;
              else if( part.act_quantity >= part.part_unit_prices[price_index+1].qty)
                  unit_price = part.part_unit_prices[price_index+1].chf;
            }
          }
            return unit_price * part.act_quantity;
        },
        uncollapse: function(e, id) {
          const sender = e.target;
          if(sender.nodeName != "BUTTON") {
            var content = document.getElementById("content_"+id)
            if (content.style.display === "") {
              content.style.display = "none";
            } else {
              content.style.display = ""; //just use the style settings defined by the other classes
            }
          }
        },
        cancelOrder: function( e, orderid ) {
            const sender = e.target;
            if( confirm("Cancel order number " + orderid + "?") ){
                console.log("Cancelling order ", orderid)
                var payload = {
                    'order_id' : orderid
                }
                console.log(JSON.stringify(payload))
                fetch( process.env.VUE_APP_URL + "/restapi/order/cancel", {
                    method: "POST", 
                    headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                    }).then(res => {
                        // console.log(res)
                        res.json().then(
                            (response) => {
                                console.log("Request complete! response:", response);
                                if (response.status == 0) {
                                    sender.disabled = true;
                                    alert("Successfully cancelled order")
                                    location.reload();
                                }
                                else {
                                    alert("ERROR \n" + response.msg);
                                }
                            }
                        );
                });
            }
            else {
                console.log("Not cancelling the order");
            }
        },
    }
}
</script>
